<template>
    <div v-if="loadingCourse || localLoading" class="lg:col-span-6 col-span-12">
        <DashboardCardSkeleton />
    </div>
    <div
        v-if="!localLoading && courseProgress < 100"
        class="col-span-12 lg:col-span-6 overflow-hidden shadow bg-white rounded-lg relative"
    >
        <div class="rounded-lg p-6 h-auto relative">
            <div class="mb-2 flex flex-col justify-start">
                <div class="flex flex-row items-center justify-between w-full">
                    <div class="flex flex-row gap-2 items-center">
                        <Icon icon="courses" class="text-slate-800" />
                        <div class="text-slate-800 text-lg font-medium">
                            10x Course
                        </div>
                    </div>
                    <a
                        href="/course/"
                        class="link-dark link-base !gap-0"

                        tabindex="0"
                        id="hs-dashboard-course-view-details"
                    >
                        View details
                        <Icon icon="arrow" />
                    </a>
                </div>
                <h3
                    class="text-slate-800 font-semibold text-lg lg:text-xl xl:text-2xl leading-10 md:mt-9 text-left"
                >
                    {{ course.title }}
                </h3>
                <div
                    class="py-4 prose text-slate-500 font-normal text-sm text-left"
                    v-html="course.description"
                ></div> 
            </div>

            <div class="px-3">
                <ProgressBar class="w-2/3" />
            </div>

            <div
                class="bg-[#F1F5F9] rounded-md p-6 flex flex-row gap-6 items-center w-full mt-9"
            >
                <div class="flex flex-col gap-1 items-start flex-1">
                    <h4 class="text-tertiary text-sm font-medium">
                        Current lesson
                    </h4>
                    <h2
                        class="text-slate-800 text-xl font-medium w-full break-words"
                    >
                        {{ currentChapter.title }}
                    </h2>
                </div>
                <a
                    :href="`/course/chapters/${currentChapter.slug}`"
                    class="btn-icon btn-10x-orange !rounded-full"
                    id="hs-dashboard-course-continue"
                >
                    <Icon icon="chevron-right" class="text-white" />
                </a>
            </div>
        </div>
    </div>
    <CourseFinish v-else-if="!localLoading" />
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';
import ProgressBar from '@/components/courses/progress-bar.vue';
import CourseFinish from '@/components/dashboard/cards/course-finish.vue';
import Icon from '@/components/ui/icon/icon.vue';
import DashboardCardSkeleton from '@/components/dashboard/cards/dashboard-card-skeleton.vue';

const coursesStore = useCoursesStore();
const { course, loadingCourse } = storeToRefs(coursesStore);

const localLoading = ref(true);

const currentChapter = computed(() => {
    for (const section of course.value.sections) {
        for (const chapter of section.chapters) {
            if (chapter.user_status === 'started') {
                return chapter;
            }
        }
    }
    return { title: 'No current lesson' };
});

const courseProgress = computed(() => {
    const totalChapters = course.value.sections.reduce(
        (total, section) => total + section.chapters.length,
        0
    );
    const completedChapters = course.value.sections.reduce(
        (total, section) =>
            total +
            section.chapters.filter(
                (chapter) => chapter.user_status === 'complete'
            ).length,
        0
    );
    return (completedChapters / totalChapters) * 100;
});

watch(
    () => courseProgress.value,
    () => {
        localLoading.value = false;
    },
    { immediate: true }
);
</script>
